export default "__VITE_ASSET__b52fcd50__"